import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import persistedState from 'vuex-persistedstate'
export default new Vuex.Store({
    plugins: [persistedState(
        {
            storage: window.sessionStorage
        }
    )],
    state: {
        token: '',
        userInfo: {},
        screenWidth: '',
    },
    mutations: {
        // 设置token
        setToken(state, token) {
            state.token = token;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        setScreenWidth(state, screenWidth){
            state.screenWidth = screenWidth
        }
    },
    actions: {},
    modules: {}
})